import { render, staticRenderFns } from "./ArrearsEnquiryDetail.vue?vue&type=template&id=4215ad1f&scoped=true"
import script from "./ArrearsEnquiryDetail.vue?vue&type=script&lang=js"
export * from "./ArrearsEnquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./ArrearsEnquiryDetail.vue?vue&type=style&index=0&id=4215ad1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215ad1f",
  null
  
)

export default component.exports